// Windows native error lookup is fused off in the web build.
module.exports = {
    InitHook: () => undefined,
    GetLastError: () => ({ code: 0, message: "" }),
};
